/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2024 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Print Message
 *
 * @file PrintMessage.jsx
 * @author Gladson Samuel S
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  TextContainer,
  ContentContainer,
  Title,
  Description,
  Illustration
} from './styles/PrintMessageStyles';

const PrintMessage = ({
  title,
  description,
  illustration,
  component
}) => (
  <Container id="one-reader-print-message">
    <TextContainer>
      {title && <Title variant="h2">{title}</Title>}
      {description && <Description>{description}</Description>}
    </TextContainer>
    <ContentContainer>
      {illustration && <Illustration alt="" src={illustration} />}
      {component && (
      <Fragment>
        {component}
      </Fragment>
      )}
    </ContentContainer>
  </Container>
);

PrintMessage.defaultProps = {
  title: '',
  description: '',
  illustration: '',
  component: () => {}
};

PrintMessage.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  illustration: PropTypes.string,
  component: PropTypes.func
};

export default PrintMessage;
